import { InputSelect } from 'timeone-components';

import useInput from './Input/useInput';

const Select = useInput(InputSelect);

export default Select;
